import React, { useState, useEffect } from 'react';
import {
    AppBar,
    Toolbar,
    Box,
    Button,
    styled,
    Typography,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Divider,
    ListItemIcon,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import SchoolIcon from '@mui/icons-material/School';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import { Link } from 'react-router-dom';
import LogoIMDI from '../../assets/LogoIMDI.webp';

const StyledToolbar = styled(Toolbar)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };
    
    const handleCloseDrawer = () => {
        setDrawerOpen(false);
    };
    

    return (
        <AppBar
            component="nav"
            position="fixed"
            sx={{
                top: isScrolled ? '16px' : 0, // Original: Cambia top al hacer scroll
                left: '50%',
                transform: `translateX(-50%) ${isScrolled ? 'translateY(-5px)' : 'translateY(0)'}`, // Agrega desplazamiento vertical
                width: isScrolled ? '90%' : '100%', // Original: Reduce el ancho
                backgroundColor: isScrolled
                    ? 'rgba(255, 255, 255, 0.4)' // Opacidad al hacer scroll
                    : 'rgba(255, 255, 255, 0.6)',
                backdropFilter: 'blur(10px)',
                borderRadius: isScrolled ? '12px' : '0', // Original: Añade bordes redondeados
                boxShadow: isScrolled ? '0px 8px 20px rgba(0, 0, 0, 0.15)' : 'none',
                transition: 'all 0.3s ease-in-out', // Transición suave
                zIndex: 1100,
            }}
            elevation={0}
        >
            <StyledToolbar>
                {/* Logo */}
                <Box 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1 
                    }}
                >
                    <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            src={LogoIMDI}
                            alt="Logo IMDI"
                            style={{
                                height: '50px',
                                objectFit: 'contain',
                                cursor: 'pointer',
                            }}
                        />
                    </Link>
                    <Link to="/" style={{textDecoration: "none"}} >
                        <Typography
                        
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: '1.2rem', sm: '1.5rem' },
                                textTransform: 'uppercase',
                                background: 'rgb(51, 64, 64)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            Tuxtla
                        </Typography>
                    </Link>
                </Box>

                {/* Botones principales */}
                <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 3 }}>
                    {[
                        { text: 'Inicio', to: '/' },
                        { text: 'Diplomados', to: '/about' },
                        { text: 'Notas Informativas', to: '/notas-informativas' },
                    ].map((item, index) => (
                        <Button
                            key={index}
                            component={Link}
                            to={item.to}
                            sx={{
                                color: 'rgb(48, 48, 48)',
                                textTransform: 'capitalize',
                                fontSize: '1rem',
                                fontWeight: 500,
                                "&:hover": {
                                    color: 'rgb(32, 32, 32)',
                                },
                            }}
                        >
                            {item.text}
                        </Button>
                    ))}
                    <Button
                        component={Link}
                        to="/contact"
                        sx={{
                            color: '#fff',
                            backgroundColor: 'rgb(48, 64, 64)',
                            textTransform: 'capitalize',
                            fontSize: '1rem',
                            fontWeight: 600,
                            borderRadius: '8px',
                            padding: '0.5rem 1.5rem',
                            "&:hover": {
                                backgroundColor: 'rgb(32, 48, 48)',
                            },
                        }}
                    >
                        Registro
                    </Button>
                </Box>

                {/* Menú hamburguesa */}
                <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
                    <IconButton onClick={toggleDrawer(true)} aria-label="menu">
                        <MenuIcon />
                    </IconButton>
                    <Drawer
                        anchor="left"
                        open={drawerOpen}
                        onClose={toggleDrawer(false)}
                        PaperProps={{
                            sx: {
                                width: 280,
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                backdropFilter: 'blur(10px)',
                            },
                        }}
                    >
                        <Box sx={{ padding: 2, display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="h6">Menú</Typography>
                            <IconButton onClick={toggleDrawer(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Divider />
                        <List>
                            {[
                                { text: 'Inicio', to: '/', icon: <HomeIcon /> },
                                { text: 'Diplomados', to: '/about', icon: <SchoolIcon /> },
                                { text: 'Notas Informativas', to: '/notas-informativas', icon: <NewspaperIcon /> },
                                { text: 'Registro', to: '/contact', icon: <HowToRegIcon /> },
                            ].map((item, index) => (
                                <ListItem button key={index} component={Link} to={item.to}  onClick={handleCloseDrawer}>
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.text} />
                                </ListItem>
                            ))}
                        </List>
                    </Drawer>
                </Box>
            </StyledToolbar>
        </AppBar>
    );
};

export default Navbar;